<script setup lang="ts">
import { onBeforeMount, ref, provide, computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'

import useContextStore from '@/stores/context'
import useLayoutStore from '@/stores/layout'

import useCdcProps from '@/composables/useCdcProps'

import type { MaterialIcon } from '@/types/components.interfaces'

const { locale } = useI18n()
const route = useRoute()
const { xprops, context } = useCdcProps()
const dialogContext = xprops.dialogContext as any

const contextStore = useContextStore()
useLayoutStore()

const showHeader = ref(true)
function setShowHeader(value: boolean) {
  showHeader.value = value
}
provide('dialogShowHeader', {
  dialogShowHeader: showHeader.value,
  setDialogShowHeader: setShowHeader,
})

const title = ref(route.meta.title)
function setTitle(value: string) {
  title.value = value
}
provide('dialogTitle', { dialogTitle: title.value, setDialogTitle: setTitle })

const iconColor = ref('theme-layout-secondary')
function setIconColor(value: string) {
  iconColor.value = value
}
provide('dialogIconColor', {
  dialogIconColor: iconColor.value,
  setDialogIconColor: setIconColor,
})

const icon = ref<MaterialIcon>('info')
function setIcon(value: MaterialIcon) {
  icon.value = value
}
provide('dialogIcon', { dialogIcon: icon.value, setDialogIcon: setIcon })

function closeDialog() {
  const xprops = (window as any).xprops
  xprops.handleCloseDialog()
}

onBeforeMount(() => {
  contextStore.setContext(context)
  locale.value = contextStore.isoLang as string
})

const getBgIconColor = computed(() => {
  switch (iconColor.value) {
    case 'purple':
      return 'bg-purple-50'
    case 'yellow':
      return 'bg-yellow-50'
    case 'red':
      return 'bg-red-50'
    case 'blue':
      return 'bg-blue-50'
    default:
      return null;
  }
})    
</script>

<template>
  <ErrorBoundary>
    <div :class="dialogContext?.size == 'sm' ? 'p-6' : 'p-8'">
      <div v-if="showHeader" class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-2">
          <div
            class="w-10 h-10 rounded-full flex items-center justify-center"
            :class="getBgIconColor"
          >
            <UiIcon :name="icon" />
          </div>
          <h1 class="text-2xl font-bold">{{ title }}</h1>
        </div>

        <UiButton
          variant="primary-reverse"
          left-icon="close"
          class="w-12 h-12 rounded-full"
          @click="closeDialog"
        >
        </UiButton>
      </div>
      <slot></slot>
    </div>
  </ErrorBoundary>
</template>
